<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '440px' }"></p-confirmDialog>

<div class="saas-page">
  <div class="saas-header">
    <div>
      <h1 class="saas-title">Team Members</h1>
      <p class="saas-subtitle">Manage your company users and their access roles.</p>
    </div>
    <div class="saas-actions" *ngIf="agents.length > 0">
      <p-button
        label="Add Member"
        icon="pi pi-user-plus"
        [disabled]="userLimitReached"
        pTooltip="Please upgrade to premium feature"
        [tooltipDisabled]="!userLimitReached"
        (onClick)="openAddDialog()"
      ></p-button>
    </div>
  </div>

  <div class="team-guidance" *ngIf="agents.length === 0">
    <div class="guidance-card">
      <div class="guidance-copy">
        <h3>What you can do here</h3>
        <p>Invite teammates, assign roles, and control access across your workspace.</p>
      </div>
      <ul class="guidance-list">
        <li>Invite agents and managers</li>
        <li>Assign roles and permissions</li>
        <li>Manage access as your team grows</li>
        <li>Remove inactive members quickly</li>
      </ul>
      <button pButton label="Invite your first teammate" icon="pi pi-user-plus" class="p-button-sm p-button-outlined guidance-action" (onClick)="openAddDialog()"></button>
    </div>
  </div>

  <div class="saas-table-card">
    <p-table [value]="agents" [rows]="10" [paginator]="true" responsiveLayout="scroll" styleClass="p-datatable-sm saas-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Email Address</th>
          <th>Roles</th>
          <th style="width: 100px">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-agent>
        <tr>
           <td>{{ agent.name }}</td>
          <td>{{ agent.email }}</td>
          <td>
            <div class="flex gap-1">
              <span *ngFor="let role of agent.roles" class="role-badge">{{ role }}</span>
            </div>
          </td>
          <td>
            <div class="flex justify-center gap-2 team-action-icons">
              <button pButton icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger" (click)="confirmDelete(agent)" pTooltip="Remove member" tooltipPosition="left"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center py-12 text-slate-400">
            <i class="pi pi-users text-3xl mb-2"></i>
            <p>No team members found. Invite your first teammate.</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="Invite Team Member"
  [(visible)]="showAddDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', height: '70vh' }"
  appendTo="body"
  contentStyleClass="team-dialog"
>
  <form [formGroup]="form" (ngSubmit)="addEmployee()" class="team-form-body">
    <div class="mb-4">
            <label class="block font-medium mb-1">Name *</label>
            <input pInputText placeholder="Enter Name" formControlName="name" class="w-full" [ngClass]="{'ng-invalid ng-dirty': isInvalid('name')}"/>
            <small class="p-error" *ngIf="isInvalid('name')">Valid Name is required.</small>
        </div>
    <div class="mb-4">
      <label class="block font-medium mb-1">Work Email *</label>
      <input pInputText formControlName="email" placeholder="name@company.com" class="w-full" [ngClass]="{'ng-invalid ng-dirty': isInvalid('email')}" />
      <small class="p-error" *ngIf="isInvalid('email')">Valid email is required.</small>
    </div>

    <div class="mb-4">
      <label class="block font-medium mb-1">Assign Roles *</label>
      <p-multiSelect appendTo="body" filterPlaceHolder="Search" [options]="roleOptions" formControlName="roles" placeholder="Select Roles" styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty': isInvalid('roles')}"></p-multiSelect>
    </div>

    <div class="mb-4">
      <label class="block font-medium mb-1">Temporary Password *</label>
      <div class="flex gap-2">
        <input pInputText formControlName="password" placeholder="At least 6 characters" class="w-full flex-1" [ngClass]="{'ng-invalid ng-dirty': isInvalid('password')}" autocomplete="off" />
        <button pButton type="button" label="Generate" icon="pi pi-refresh" class="p-button-outlined p-button-sm" (click)="generatePassword()"></button>
      </div>
      <small class="p-error" *ngIf="isInvalid('password')">Password must be at least 6 characters.</small>
      <small class="block mt-1 text-slate-500" *ngIf="!isInvalid('password')">Share this with the new user. They'll be asked to set their own password the first time they sign in.</small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="team-dialog-footer">
      <p-button label="Cancel" class="p-button-text" (onClick)="showAddDialog=false"></p-button>
      <p-button label="Invite Member" [loading]="loading" (onClick)="addEmployee()"></p-button>
    </div>
  </ng-template>
</p-dialog>
